module.exports = __webpack_public_path__ + "img/Airbnb-Work-From-Home-Home-Essentials2--scaled.005dfee1.jpg";